import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';

class FilterByLineGroup extends Component {
    setGroup(priority, isChecked) {
        const lineGroups = {...this.props.lineGroupFilter.lineGroups};
        lineGroups[priority] = isChecked;

        this.props.dispatch(Action.set('LineGroups', lineGroups));
    }

    render() {
        const {lineGroupFilter} = this.props;

        return (
            <div>
                <strong className="filter-sub-title">Line grouping:</strong>
                <div className="inline-holder">
                    {Object.keys(lineGroupFilter.lineGroups).map((groupNumber) => {
                        const isChecked = lineGroupFilter.lineGroups[groupNumber];

                        return (
                            <label key={groupNumber} className="checkbox-inline">
                                <input
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={(e) => ::this.setGroup(groupNumber, e.target.checked)}
                                />
                                {groupNumber}
                            </label>
                        );
                    })}
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {lineGroupFilter} = state.playersData;

    return {
        lineGroupFilter,
    };
}

export default connect(mapStatesToProps)(FilterByLineGroup);
